import React from 'react'

import { Typography } from 'antd'

import './styles.less'

export function PageTitle({ title, className }) {
  return (
    <Typography.Title className={`defaultPageTitle ${className}`} level={3}>
      {title}
    </Typography.Title>
  )
}
